import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAccountAdminQuery } from '../Admin/Account/useAdminAccountQuery';

export const useSetGoogleBusinessBrandingSettings = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
}) => {
	const userSession = useUserSession();
	const effectiveImpersonationContext = impersonationContext ?? userSession.impersonationContext;

	return useMutation({
		mutationFn: (brandingSettings: Api.IGoogleBusinessBrandingSettings) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: effectiveImpersonationContext,
					urlPath: 'account/preferences/googleReviewPostBranding',
				}),
				'PUT',
				brandingSettings
			);
		},
		onError,
		onSuccess: () => {
			invalidateAccountAdminQuery();
			onSuccess?.();
		},
	});
};
